import { render, staticRenderFns } from "./preview05.vue?vue&type=template&id=a5206766&scoped=true"
import script from "./preview05.vue?vue&type=script&lang=js"
export * from "./preview05.vue?vue&type=script&lang=js"
import style0 from "./preview05.vue?vue&type=style&index=0&id=a5206766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5206766",
  null
  
)

export default component.exports